export const updateItemCount = (selector, count) => {
    const countElement = document.querySelector(`[data-js-selector="${selector}-count"]`);
    const headerItemElements = document.querySelectorAll(`[data-js-selector="header-${selector}-item"]`);

    if (count == 0) {
        countElement?.remove();
        headerItemElements.forEach((item) => item.classList?.remove('active'));
    } else {
        headerItemElements.forEach((item) => {
            if (!item.classList.contains('active')) {
                item.classList.add('active');
                item.insertAdjacentHTML(
                    'afterbegin',
                    `<div class="header__item-count" data-js-selector="${selector}-count">${count}</div>`,
                );
            }
        });

        if (countElement) {
            countElement.textContent = count;
        }
    }
};

export const getProductItemsTotalCount = (dataCart) => {
    if(!dataCart) {
        return 0;
    }
    
    const productItems = dataCart.items.filter((item) => !('Service' in item.properties || '_isService' in item.properties));
    const productItemsTotalCount = productItems.reduce((accumulator, item) => {
        return accumulator + item.quantity;
    }, 0);

    return productItemsTotalCount;
};

const handleQuantityChange = (event) => {
    const itemId = event.target.dataset.itemId;
    const quantity = event.target.value;

    fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            id: itemId,
            quantity: quantity,
        }),
    })
        .then((response) => response.json())
        .then((data) => {
            this.refresh();
        });
};

const addQuantityChangeListeners = (input) => {
    input.addEventListener('change', handleQuantityChange);
};

const init = () => {
    const quantityInputs = document.querySelectorAll('.item-quantity');

    quantityInputs.forEach(addQuantityChangeListeners);
};

document.addEventListener('DOMContentLoaded', init);
